// Import and register all your controllers from the importmap under controllers/*
import { application } from "./application"
import RailsNestedForm from '@stimulus-components/rails-nested-form'
import { attachTooltips } from '../lib/tooltips'
import { attachHoverCopy } from '../lib/hover_copy'
import { attachTaskActionFeedback } from '../lib/task_action_feedback'
import { attachMorphKeep } from '../lib/morph_keep'
import { attachAnswerSheetFocus } from '../lib/answer_sheet_focus'
import { attachRichtext } from '../lib/richtext_loader'

// Eager load all controllers defined in the import map under controllers/**/*_controller
// import { eagerLoadControllersFrom } from "@hotwired/stimulus-loading"
// eagerLoadControllersFrom("controllers", application)

// Lazy load controllers as they appear in the DOM (remember not to preload controllers in import map!)
// import { lazyLoadControllersFrom } from "@hotwired/stimulus-loading"
// lazyLoadControllersFrom("controllers", application)

// import DropdownController from "./dropdown_controller"
// application.register("dropdown", DropdownController)

const controllers = [
  'syntax_highlight',
  'simple_collection',
  'collection_review',
  'suggestion_pick',
  'task_kind_form',
  'kind_picker',
  'list_filter',
  'leave_after',
  'form',
  'menu',
  'index_view',
  'has_modal',
  'frame_modal',
  'modal_router',
  'hotkey',
  'agent_form',
  'agent_objectives',
  'agent_objective',
  'agent_contact_roles',
  'agent_contact_role',
  'agent_command_shortcut',
  'uploadzone',
  'pdf_viewer',
  'csv_viewer',
  'text_viewer',
  'removeable',
  'hcaptcha',
  'recaptcha',
  'icon_selector',
  'prompt_versions',
  'attachments_modal',
  'viewer_panel',
  'process_table',
  'process_index',
  'contacts_table',
  'documents_table',
  'tasks_table',
  'usage_table',
  'admin_ai_usage',
  'audits_table',
  'audits_security_table',
  'agent_data_extraction_keys',
  'agent_data_extraction_key',
  'agent_chat',
  'activity_stream',
  'report_status',
  'completed_event_uploads',
  'process_show',
  'command_palette',
  'task_show',
  'auto_submit',
  'mobile_menu',
  'sidebar_collapse',
  'toggle_context',
  'details_memory',
  'sticky_fade',
  'tooltip',
  'viewer_data_toggle',
  'viewer_shell',
  'attachment_view_toggle',
  'mentions',
  'ai_select',
  'scheduled_command_form',
  'expandable_content',
  'task_action_event',
  'sanitize_input',
  'ftp_subscription',
  'remember_param',
  'dismissable',
  'board_scroll',
  'board_triage',
  'board_columns',
  'board_view',
  'board_work',
  'board_task',
  'board_saved_views',
  'board_selection',
  'deferred_frame',
  'option_select',
  'kanban',
  'board_list_selector',
  'quick_selector',
  'color_picker',
  'task_upload',
  'public_upload',
  'marketing_carousel',
  'marketing_demo',
  'marketing_nav',
  'reveal',
  'tabs',
  'scroll_fade',
  'emoji_picker',
  'dynamic_list',
  'collapsible',
  'sop_templates',
  'requires_notes',
  'review_queue',
  'review_loader',
  'extracted_data_editor',
  'value_expand',
  'searchable_select',
  'contact_resolution_mode',
  'agent_delegation_templates',
  'agent_delegation_template',
  'delegation_template_picker',
  'delegation_review',
  'pdf_review',
  'email_combobox',
  'note_form',
  'checkbox_toggle',
  'classification_field',
  'clipboard',
  'sheet_expand',
  'sheet_fold',
  'pane',
  'dialog_fullscreen',
  'cookie_consent',
  'support_request',
  'resource_preview',
  'triage_prompt_picker',
  'triage_review',
  'similar_strip',
  'decision_queue',
  'triage_list',
  'ask_user_marker',
  'ask_user_prompt',
  'task_dock',
  'elapsed',
  'story_line',
  'timeline_fresh',
  'narrated_lens',
  'table_density',
  'value_locate',
  'pdf_find',
  'card_density',
  'timeline_width',
  'reference_chips',
  'filename_fit',
  'run_line_fit',
  'capability_selector',
  'api_token_audience',
  'account_switcher',
  'relative_time',
  'live_window',
  'paper_moment',
  'ref_card',
  'file_shelf',
  'task_age',
  'age_stamp',
  'autogrow',
  'fact_overflow',
];

controllers.forEach(async (name) => {
  const controller = await import(`./${name}_controller.js`);
  application.register(name.replace(/_/g, '-'), controller.default);
});

application.register('nested-form', RailsNestedForm)

// Hover-to-copy on table cells, inline code and code blocks in rendered markdown.
attachHoverCopy()
attachTaskActionFeedback()
attachMorphKeep()
attachAnswerSheetFocus()

// Standardize tooltips app-wide: attach the smart `tooltip` controller to
// every [data-tip] element (daisyUI's CSS tooltip is suppressed in CSS), so
// all tooltips render into <body> with edge-aware positioning. Covers the
// initial page, Turbo visits, and turbo-stream-injected DOM.
attachTooltips()
document.addEventListener('turbo:load', () => attachTooltips())
new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue
      if (node.hasAttribute('data-tip') || node.querySelector('[data-tip]')) {
        attachTooltips(node)
      }
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true })

attachRichtext(application)
